/**
 * Scroll module that handles smooth scrolling to elements
 */
export function initScroll() {
  // Handle smooth scroll links
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]:not([href="#"])');
    if (!link) return;
    
    e.preventDefault();
    
    const targetId = link.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    
    if (!targetElement) return;
    
    // Get header height for offset
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    
    // Calculate target position
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
    
    // Smooth scroll to target
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
    
    // Update URL hash without jumping
    history.pushState(null, null, targetId);
  });
  
  // Handle scroll to top button
  const scrollTopButton = document.querySelector('.scroll-top');
  if (scrollTopButton) {
    // Show/hide button based on scroll position
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 300) {
        scrollTopButton.classList.add('is-visible');
      } else {
        scrollTopButton.classList.remove('is-visible');
      }
    });
    
    // Scroll to top when clicked
    scrollTopButton.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
} 